/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Confirmdeletedesc2Inputs */

const zh_danger_confirmdeletedesc2 = /** @type {(inputs: Danger_Confirmdeletedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此操作将永久删除您的账户、所有数据和相关资源，且不可恢复。`)
};

const en_danger_confirmdeletedesc2 = /** @type {(inputs: Danger_Confirmdeletedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will permanently delete your account, all data, and related resources. This action cannot be undone.`)
};

const es_danger_confirmdeletedesc2 = /** @type {(inputs: Danger_Confirmdeletedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta acción eliminará permanentemente tu cuenta, todos los datos y recursos relacionados. No se puede deshacer.`)
};

/**
* | output |
* | --- |
* | "This will permanently delete your account, all data, and related resources. This action cannot be undone." |
*
* @param {Danger_Confirmdeletedesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_confirmdeletedesc2 = /** @type {((inputs?: Danger_Confirmdeletedesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Confirmdeletedesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_confirmdeletedesc2(inputs)
	if (locale === "en") return en_danger_confirmdeletedesc2(inputs)
	return es_danger_confirmdeletedesc2(inputs)
});
export { danger_confirmdeletedesc2 as "danger_confirmDeleteDesc" }